import { gql } from "@apollo/client";

export const POINT_FIELDS_FRAGMENT = gql`
  fragment PointFields on Point {
    id
    brandId
    cityId
    address
    name
    priority
    isActive
    brand {
      id
      name
      slug
    }
    city {
      id
      name
    }
  }
`;

export const GET_POINT = gql`
  ${POINT_FIELDS_FRAGMENT}
  query Point($input: PointInput!) {
    point(input: $input) {
      ...PointFields
    }
  }
`;

export const GET_POINTS = gql`
  ${POINT_FIELDS_FRAGMENT}
  query Points($input: PointsInput!) {
    points(input: $input) {
      ...PointFields
    }
  }
`;

export const COUNT_POINTS = gql`
  query CountPoints($input: PointCountInput!) {
    countPoints(input: $input)
  }
`;

// Add mutation constants based on the schema
export const CREATE_POINT = gql`
  mutation CreatePoint($input: PointCreateInput!) {
    pointCreate(input: $input) {
      ...PointFields
    }
  }
  ${POINT_FIELDS_FRAGMENT}
`;

export const UPDATE_POINT = gql`
  mutation UpdatePoint($input: PointUpdateInput!) {
    pointUpdate(input: $input) {
      ...PointFields
    }
  }
  ${POINT_FIELDS_FRAGMENT}
`;

export const DELETE_POINT = gql`
  mutation DeletePoint($input: PointDeleteInput!) {
    pointDelete(input: $input)
  }
`;
